import * as React from "react";
import {useHistory} from "react-router-dom";
import {Card, CardContent, Grid, Typography} from "@material-ui/core";
import AccountList from "../../accounts/AccountList";
import {noop} from "../../../utils/commonUtils";
import {cssPaths, GIFTOR_PORTAL, PARENT_POSTAL} from "../../../constants";


interface RecipientsPoliciesListProps {
    parentId?: string,
}

const RecipientPoliciesList: React.FC<any> = (props: RecipientsPoliciesListProps) => {
    const { parentId } = props;
    const hist = useHistory();

    return (
            <Card className="boxShadow mt20">
                <CardContent>
                    <Grid item xs={12} sm={8} md={10}>
                        <Typography variant="h3" align="left">
                            Recipient Policies
                        </Typography>
                    </Grid>
                    <Grid className={"adminClasses mt10"} container spacing={1}>
                        <Grid item xs={12}>
                            <AccountList
                                    callingFrom={PARENT_POSTAL}
                                    listType={"main"}
                                    defaultBasePath={GIFTOR_PORTAL}
                                    history={hist}
                                    role={"individual"}
                                    setTitle={noop}
                                    parentId={parentId}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
    )
};

export default RecipientPoliciesList;